import { motion } from "framer-motion";
import { useSiteLang } from "../lib/siteLang";

// The real screens of the app, in the order of a visit: choose the tour, its home, the two maps, a point, the ports, the info page
const screens = [
  { url: "/images/screenshot-find-tour.webp", alt: "GozzoGuide — Trova il tuo tour" },
  { url: "/images/screenshot-tour-home.webp", alt: "GozzoGuide — Tour di Capri" },
  { url: "/images/screenshot-sea-map.webp", alt: "GozzoGuide — mappa del tour in barca" },
  { url: "/images/screenshot-land-map.webp", alt: "GozzoGuide — mappa del tour a terra" },
  { url: "/images/screenshot-point.webp", alt: "GozzoGuide — scheda di un punto" },
  { url: "/images/screenshot-ports.webp", alt: "GozzoGuide — porti di imbarco" },
  { url: "/images/screenshot-info.webp", alt: "GozzoGuide — Info" },
];

export const Screenshots = () => {
  const { t } = useSiteLang();

  return (
    <section className="section-padding bg-[#09101F] overflow-hidden" data-testid="screenshots-section">
      <div className="max-w-6xl mx-auto px-5 md:px-10">
        <div className="text-center mb-12 md:mb-14 max-w-2xl mx-auto">
          <p className="section-label mb-4" data-testid="screenshots-label">{t.screensLabel}</p>
          <h2 className="text-3xl md:text-5xl text-white" style={{ textWrap: "balance" }} data-testid="screenshots-title">
            {t.screensTitle}
          </h2>
        </div>
      </div>

      {/* A strip that scrolls sideways (with snap) on every screen: seven phones do not fit in a row */}
      <div
        className="flex gap-6 md:gap-8 overflow-x-auto snap-x snap-mandatory px-5 md:px-10 pb-6 [scrollbar-width:thin]"
        tabIndex={0}
        role="region"
        aria-label={t.screensTitle}
        data-testid="screenshots-strip"
      >
        {screens.map((screen, index) => (
          <motion.figure
            key={screen.url}
            initial={{ y: 24 }}
            whileInView={{ y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: Math.min(index, 3) * 0.06, ease: [0.16, 1, 0.3, 1] }}
            className="snap-center shrink-0 first:ml-auto last:mr-auto"
            data-testid={`phone-${index}`}
          >
            <div className="w-56 md:w-60 rounded-[2.25rem] overflow-hidden border-[5px] border-[#0C1A2E] ring-1 ring-white/15 shadow-2xl">
              <img src={screen.url} alt={screen.alt} className="w-full h-auto block" loading="lazy" width="640" height="1254" />
            </div>
            <figcaption className="text-center mt-4 text-sm text-white/80">{t.shots[index]}</figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
};
